export interface PairingTicket { code: string; expiresAt: string }

export function pairingOrigin(raw: string) {
  try {
    const u = new URL(raw);
    return raw.length <= 2048 && u.protocol === 'https:' && !u.username && !u.password && !u.search && !u.hash && u.pathname === '/' && raw === u.origin;
  } catch { return false; }
}

export function pairingTicketRequest(name: string, expectedAppBossBaseUrl: string) {
  if (!name.trim() || new TextEncoder().encode(name.trim()).length > 200 || !pairingOrigin(expectedAppBossBaseUrl)) throw new Error('Invalid pairing request');
  return { name: name.trim(), expectedAppBossBaseUrl };
}

export function publicPairingTicket(value: unknown, now = Date.now()): PairingTicket {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid pairing response');
  const v = value as Record<string, unknown>;
  if (Object.keys(v).length !== 2 || typeof v.code !== 'string' || !/^agpair_[A-Za-z0-9_-]{43}$/.test(v.code) || typeof v.expiresAt !== 'string' ||
      !Number.isFinite(Date.parse(v.expiresAt)) || Date.parse(v.expiresAt) <= now || Date.parse(v.expiresAt) > now + 610_000) throw new Error('Invalid pairing response');
  return { code: v.code, expiresAt: v.expiresAt };
}

export function pairingError(error: unknown) {
  const value = error as { status?: number; code?: string };
  if (value?.status === 401 || value?.status === 403) return '登录已失效或没有操作权限，请重新登录。';
  if (value?.status === 429) return '生成过于频繁，请稍后重试。';
  switch (value?.code) {
    case 'pairing_expired': return '配对码已过期，请重新生成。';
    case 'pairing_integration_exists': return '此 AppBoss 已有连接，请选择已有连接；不会覆盖原设置。';
    case 'pairing_conflict': return '本次配对已被另一份请求使用，请核对 AppBoss 中的连接状态。';
    case 'pairing_invalid': return '名称或 AppBoss 服务地址格式不正确。';
    default: return '生成结果未确认，请检查连接后重试。';
  }
}
